import { createResourceListQuery } from "queries";
import types from "resources/types";

export const positionTypesQuery = () =>
  createResourceListQuery(types.POSITION_TYPES, {
    url: "/api/v2/position_types/?limit=999",
  });
